import { useState } from 'react';
import { STORAGE_KEYS } from '../_internal';

type ConsentStatus = 'accepted' | 'declined' | null;

function readConsent(): ConsentStatus {
  try {
    return (localStorage.getItem(STORAGE_KEYS.cookieConsent) as ConsentStatus) ?? null;
  } catch {
    return null;
  }
}

function writeConsent(value: ConsentStatus): void {
  try {
    if (value) localStorage.setItem(STORAGE_KEYS.cookieConsent, value);
  } catch {
  }
}

export function useCookieConsent() {
  const [consent, setConsent] = useState<ConsentStatus>(readConsent);

  const accept = () => {
    writeConsent('accepted');
    setConsent('accepted');
  };

  const decline = () => {
    writeConsent('declined');
    setConsent('declined');
  };

  return {
    consent,
    showBanner: consent === null,
    accept,
    decline,
  };
}
